export default __webpack_public_path__ + "static/media/happy.233fc935.svg";